import global from "./global.js";
import zsTj from "./tj/zs.js";

export default {
  // 全局
  ...global,
  // 图鉴
  tj: {
    // 棕色尘埃2
    zs: zsTj
  }
};
